<template>
    <!-- <section class="row clearfix">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="card">
                <div class="body">
                    <form @submit.prevent="addUserValidator()" class="flex items-end gap-x-3">
                        <p class="w-[25%] m-0">
                            
                        </p>
                        <p class="w-[25%] m-0">
                            
                        </p>
                        <p class="grow m-0">
                            
                        </p>
                        <button :disabled="asSend" class="w-[35%] h-[40px] py-3 bg-[#5357ec] text-white rounded-md">
                            <Loader2 v-if="loader" class="animate-spin mx-auto"/>
                            <span v-if="!loader">Enregistrer</span>
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </section> -->

    <DialogRoot>
        <DialogTrigger>
            <button class="bg-[#3c41e9] text-white px-[12px] rounded-xl h-[35px]">
                Ajouter validateur
            </button>
        </DialogTrigger>
        <DialogPortal>
            <DialogOverlay className="fixed z-[1000] inset-0 bg-[#00000044] data-[state=open]:animate-overlayShow"/>
            <DialogContent className="fixed w-[48%] z-[1001] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-xl bg-white pt-[25px] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none data-[state=open]:animate-contentShow">
                <DialogTitle class="m-0 text-[20px] font-medium text-center px-[25px] text-black">
                    Ajouter un validateur
                </DialogTitle>
                <DialogDescription class="text-black px-8 mt-4 text-[15px] text-center font-extralight">
                    Les champs du formulaire suivis d'un <span class="text-[#f44545]">*</span> sont obligatoire. veuillez lire le formulaire
                    avant soummition
                </DialogDescription>
                <form @submit.prevent="addUserValidator">
                    <div class="flex flex-col w-full text-black px-[16px] mt-[8px]">
                        <label for="user" class="font-light" >Sélectionner l'employée<span class="text-[#f44545]">*</span></label>
                        <select v-model="formData.selectEmployee" name="user" id="user" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                            <option value="">Choisissez l'employée</option>
                            <option v-for="user in users" :key="user.id" :value="user.id"> {{
                                            user["first_name"] + " " + user["last_name"]}} </option>
                        </select>
                    </div>

                    <div class="flex flex-col mt-[8px] w-full text-black px-[16px]">
                        <label for="profile" class="font-light" >Sélectionner le validateur<span class="text-[#f44545]">*</span></label>
                            <select v-model="formData.selectValidator" name="profile" id="profile" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none">
                                <option value="">Choisissez un validateur</option>
                                <option v-for="user in users" :key="user.id" :value="user.id"> {{
                                            user["first_name"] + " " + user["last_name"]}} </option>
                            </select>
                    </div>

                    <div class="flex flex-col mt-[8px] w-full text-black px-[16px]">
                        <label for="level" class="font-light" >Niveau de validation<span class="text-[#f44545]">*</span></label>
                        <input type="number" min="1" max="3" v-model="formData.level" name="level" class="h-[40px] w-full rounded-md border outline-none p-3 focus:outline-none" placeholder="1">
                    </div>


                    <div className="bg-[#f4f4f7] w-full py-4 mt-[8px] gap-x-[16px] px-[16px] rounded-b-md flex items-center justify-end">
                            <DialogClose asChild><button :disabled="asSend" class="px-8 h-[45px] py-3 text-[#797e91] transition-colors hover:bg-[#e9e9ec] rounded-xl">Cancel</button></DialogClose>
                            <button type="submit" class="h-[45px] w-[33%] bg-[#5357eb] rounded-xl text-white">
                                <Loader2 v-if="loader" class="animate-spin mx-auto"/>
                                <span v-if="!loader">Enregistrer</span>
                            </button>
                    </div>
                </form>
            </DialogContent>
        </DialogPortal>
    </DialogRoot>
</template>
<script>

import {
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from 'radix-vue'
import Swal from 'sweetalert2';
import API from "@/service/API.js";
import {Loader2} from "lucide-vue-next";
export default{
    name: 'AddValidator',
    components:{
        Loader2,
        DialogClose,
        DialogContent,
        DialogDescription,
        DialogOverlay,
        DialogPortal,
        DialogRoot,
        DialogTitle,
        DialogTrigger
    },
    data() {
        return {
            loader: false,
            // profiles: [],
            users: [],
            formData:{
                selectValidator:null,
                selectEmployee:null,
                level:1
            }
        }
    },
    async mounted() {
        this.getUsers()
        // this.getData()
    },
    methods:{
        addUserValidator(){
            this.loader = true;
            const data = {
                validator_id: this.formData.selectValidator,
                employee_id: this.formData.selectEmployee,
                level: this.formData.level
            }
            API.post("/validators",data)
            .then((response)=>{
                if(!response.data.status) throw Error(response.data.message);
                this.formData={
                    selectUser:null,
                    selectProfil:null,
                    level:null
                }
                Swal.fire({title: 'Succès !',text: 'Validateur enregistré',icon: 'success',})
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{this.loader = false})
        },
        updateValidator(formData){
            API.put("/validators",formData)
            .then((data)=>{
                console.log(data);
                if(data.data.status){
                    // toast.success("Succès","Validateur mis à jour",3000);
                }else{
                    // toast.erreur("Erreur","Veuillez réessayé",3000);
                }
            })
            .catch()
            .finally();
        },
        removeValidator(id){
            API.delete(`/validators/${id}`)
            .then((res)=>{
                if(res.data.status){
                    // toast.success("Succès","Validateur supprimé",3000);
                }else{
                    // toast.erreur("Erreur","Veuillez réessayé",3000);
                }
            })
            .catch()
            .finally();
        },
        // async getData() { 
        //     API.get('/getAllProfiles')
        //         .then((res) => {
        //             this.profiles = res.data.data
        //         })
        //         .catch((error) => {
        //             console.error(error)
        //         })
        // },
        getUsers() {
            API.get('/getAllEmployees')
                .then((res) => {
                    this.users = res.data.data
                })
                .catch((error) => {
                    console.error(error)
                })
        },
    }
}
</script>